import { useState, useEffect } from "react";
import EditProductModal from "./EditProductModal.jsx";
import { addCommas, removeCommas } from "@persian-tools/persian-tools";
import "./productList.scss";
import Pagination from "rc-pagination";
import sendRequest from "hooks/useAxios";
import Swal from "sweetalert2";
import ReactTooltip from "react-tooltip";
import { AiTwotoneEdit } from "react-icons/ai";
import { RiDeleteBin3Line } from "react-icons/ri";
import { CgUnavailable } from "react-icons/cg";
import { TiTickOutline } from "react-icons/ti";
import { GiUsable } from "react-icons/gi";
export default function ProductList({ data, update, setUpdate }) {
  const [currentPage, setCurrentPage] = useState(1);
  const [show, setShow] = useState(false);
  const [productList, setProductList] = useState({ ...data });
  useEffect(() => {
    setProductList(data);
  }, [data]);
  const [selectedProduct, setSelectedProduct] = useState({});
  const deleteProduct = value => {
    Swal.fire({
      title: "آیا از حذف محصول اطمینان دارید؟",

      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "حذف",
      cancelButtonText: "انصراف"
    }).then(result => {
      if (result.isConfirmed) {
        sendRequest("Update_products", {
          conditions: `id/=/${value.id}`,
          keyvalues: "main_status,-2"
        }).then(({ data }) => {
          if (data.status == 1) {
            Swal.fire("محصول با موفقیت حذف شد.");
            setUpdate(prev => {
              return !prev;
            });
          } else {
            Swal.fire("مشکلی در حذف محصول پیش آمده است.");
          }
        });
      }
    });
  };
  const disableProduct = value => {
    if (value.main_status == 0) {
      Swal.fire({
        title: "آیا از غیر فعال کردن محصول اطمینان دارید؟",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "غیر فعال کردن",
        cancelButtonText: "انصراف"
      }).then(result => {
        if (result.isConfirmed) {
          sendRequest("Update_products", {
            conditions: `id/=/${value.id}`,
            keyvalues: "main_status,-1"
          }).then(({ data }) => {
            if (data.status == 1) {
              Swal.fire("محصول با موفقیت غیر فعال شد.");
              // setActive(false);

              setUpdate(prev => {
                return !prev;
              });
            } else {
              Swal.fire("مشکلی در غیر فعال کردن محصول پیش آمده است.");
            }
          });
        }
      });
    } else {
      Swal.fire({
        title: "آیا از فعال کردن محصول اطمینان دارید؟",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: " فعال کردن",
        cancelButtonText: "انصراف"
      }).then(result => {
        if (result.isConfirmed) {
          sendRequest("Update_products", {
            conditions: `id/=/${value.id}`,
            keyvalues: "main_status,0"
          }).then(({ data }) => {
            if (data.status == 1) {
              Swal.fire("محصول با موفقیت فعال شد.");
              // setActive(true);
              setUpdate(prev => {
                return !prev;
              });
            } else {
              Swal.fire("مشکلی در فعال کردن محصول پیش آمده است.");
            }
          });
        }
      });
    }
  };
  useEffect(() => ReactTooltip.rebuild());
  return (
    <div className="productlist-style ">
      <div className="row mx-0">
        {data.length > 0 &&
          [...data]
            .reverse()
            .slice((currentPage - 1) * 12, (currentPage - 1) * 12 + 12)
            .map(value => {
              return (
                <div className="col-lg-3 col-md-4 col-sm-6 col-xs-6 mx-auto">
                  <div
                    className="bg-light p-2 my-2 mx-auto product-card"
                    style={{ width: "220px", borderRadius: "10px" }}
                  >
                    <div className="text-center position-relative">
                      <img
                        src={`http://marketgroup.tatdemo.ir/${value.url}`}
                        style={{
                          width: "150px",
                          height: "120px",
                          borderRadius: "10px"
                        }}
                      />
                      {console.log("status :", value.main_status)}
                      {value.main_status == -1 && (
                        <div
                          style={{ backgroundColor: "rgb(215 215 215 / 80%)" }}
                          className="position-absolute w-100 top-0 h-100 rounded  "
                        >
                          <span
                            className="bg-danger px-3 text-white rounded"
                            style={{
                              // color: "#ff4700",
                              transform: "rotate(-45deg)",
                              position: "absolute",
                              top: "18px",
                              left: -15,
                              fontSize: "12px"
                            }}
                          >
                            غیـــر فعــال
                          </span>
                        </div>
                      )}
                    </div>
                    <div className="bg-white rounded p-2 mt-2">
                      <h6
                        className="text-center mt-2 productlist-style"
                        style={{ height: "39px" }}
                      >
                        {value.title}
                      </h6>
                      <div>
                        <span
                          className="hashtags fs-12 text-blue "
                          style={{ height: "40px" }}
                        >
                          دسته بندی :
                          {value.hashtags.length > 0
                            ? value.hashtags.map(val => val.txt).join("، ")
                            : " -- "}
                        </span>
                      </div>
                      <div>
                        <div className="d-flex justify-content-between">
                          <span className="fs-12 fw-bold">حداقل قیمت :</span>
                          <h6 className="fs-12 mt-1 text-success">
                            {addCommas(value.price_from)}تومان
                          </h6>
                        </div>
                        <div className="d-flex justify-content-between">
                          <span className="fs-12 fw-bold">حداکثر قیمت :</span>
                          <h6 className="fs-12 mt-1 text-success">
                            {addCommas(value.price_to)}تومان
                          </h6>
                        </div>
                        <div className="d-flex justify-content-between">
                          <span className="fs-12 fw-bold">درصد سود :</span>
                          <h6 className="fs-12 mt-1 text-success">
                            {value.Interest_rates}%
                          </h6>
                        </div>
                      </div>
                      <div
                        className="mt-2"
                        style={{ borderTop: "1px solid lightgray" }}
                      >
                        <div className="d-flex justify-content-between align-items-center mt-2">
                          <h6 className="fs-12">عملیات ها</h6>
                          <div className="d-flex">
                            <button
                              type="button"
                              className="btn p-0 mx-1 product-action"
                              data-bs-toggle="modal"
                              data-bs-target="#editProductModal"
                              onClick={() => {
                                setSelectedProduct(value);
                                setShow(true);
                              }}
                              data-for="gm-tooltip"
                              data-tip="ویرایش محصول"
                            >
                              <AiTwotoneEdit />
                            </button>
                            <EditProductModal
                              setSelectedProduct={setSelectedProduct}
                              selectedProduct={selectedProduct}
                              value={value}
                              update={update}
                              setUpdate={setUpdate}
                              show={show}
                              setShow={setShow}
                            />
                            <button
                              type="button"
                              className="btn  p-0 mx-1 product-action"
                              onClick={() => {
                                deleteProduct(value);
                              }}
                              data-for="gm-tooltip"
                              data-tip="حذف محصول"
                            >
                              <RiDeleteBin3Line />
                            </button>
                            {value.main_status == 0 ? (
                              <button
                                type="button"
                                className="btn p-0 mx-1 product-action"
                                onClick={() => {
                                  disableProduct(value);
                                }}
                                data-for="gm-tooltip"
                                data-tip="غیر فعال کردن محصول"
                              >
                                <CgUnavailable />
                              </button>
                            ) : (
                              <button
                                type="button"
                                className="btn p-0 mx-1 product-action"
                                onClick={() => {
                                  disableProduct(value);
                                }}
                                data-for="gm-tooltip"
                                data-tip=" فعال کردن محصول"
                              >
                                <TiTickOutline />
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
      </div>
      <div>
        <Pagination
          className="text-center my-2"
          total={productList.length}
          pageSize={12}
          current={currentPage}
          onChange={page => {
            setCurrentPage(page);
          }}
        />
      </div>
      {/* <EditProductModal
        
        selectedProduct={selectedProduct}
        update={update}
        setUpdate={setUpdate}
        show={show}
        setShow={setShow}
      /> */}
    </div>
  );
}
